module.exports = __webpack_public_path__ + "fonts/Roboto-Bold.ab96cca2.woff2";